import React from 'react';
import FilterTable from './filterTable';
import { AccountsTableColumnCaptions } from './tableColumnCaptions';
import { jsonColumn } from './tableUtils';

const AccountsHistoryTable = props => {
  const columns = [{
    dataField: 'eventDateTime',
    text: 'Event time',
    sort: true,
    filter_: { type: 'datetime' },
  }, {
    dataField: 'eventName',
    text: 'Event name',
    sort: true,
    filter_: { type: 'text' },
  }, {
    dataField: 'device.key',
    text: 'Device key',
    filter_: { type: 'text' },
  },  {
    dataField: 'previous',
    text: 'Previous values',
    filter_: { type: 'text' },
  }, {
    dataField: 'user.login',
    text: 'User',
    sort: true,
    filter_: { type: 'text' },
  }];

  const defaultSorted = [{
    dataField: 'eventDateTime',
    order: 'desc'
  }];

  return (
    <FilterTable
      {...props}
      objectName="accountsHistory"
      data={props.history.map(histrec => ({
        ...histrec,
        previous: jsonColumn(histrec.previousValues, AccountsTableColumnCaptions)
      }))}
      columns={columns}
      defaultSorted={defaultSorted}
      noDataIndication="There are no AI accounts history records"
    />
  );
};

export default AccountsHistoryTable;



// WEBPACK FOOTER //
// ./src/components/accountsHistoryTable.js